import { createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/explain-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-9c9654ae")

_pushScopeId("data-v-9c9654ae")
const _hoisted_1 = { class: "ui__checkDetail_main" }
const _hoisted_2 = { class: "ui__checkDetail_title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__checkDetail_title_left" }, " 验货报告详情 ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "icon-explain",
  class: "icon-explain"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 检测标准说明 ")
const _hoisted_6 = { class: "ui__comTitle_model" }
const _hoisted_7 = { class: "ui__comTitle_model_title" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 检测标准说明 ")
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"ui__comTitle_model_cnt\" data-v-9c9654ae><div class=\"ui__comTitle_model_cnt_item\" data-v-9c9654ae><div class=\"ui__comTitle_model_cnt_title\" data-v-9c9654ae>事故检测标准说明</div><div class=\"ui__comTitle_model_cnt_text\" data-v-9c9654ae> 重大事故车定义：经过碰撞、维修不当、使用不当等非自然损耗因素造成严重损伤的机动车。<br data-v-9c9654ae> 判定标准：底大边内侧、底大边外侧、不可拆水箱框架、翼子板内骨架、后围板、导水槽、行李箱封边、车顶、车顶边、行李箱底板四边、C柱翼子板连接板、后翼子板存在切割；车身底板、行李箱底板、纵梁、减震器座、行李箱隔板、防火墙、A/B/C/D柱内侧及封边、门槛梁存在钣金修复、严重变形、切割、锈蚀锈透等缺陷认定为重大事故车。 </div></div><div class=\"ui__comTitle_model_cnt_item\" data-v-9c9654ae><div class=\"ui__comTitle_model_cnt_title\" data-v-9c9654ae>火烧检测标准说明</div><div class=\"ui__comTitle_model_cnt_text\" data-v-9c9654ae> 火烧车定义：车辆经燃烧、炙烤等高温作用，导致车辆部件受损或修复过后存在安全隐患的车辆。<br data-v-9c9654ae> 判定标准：减震器座、发动机舱、车身线束、发动机舱内管路、行李箱舱等部位存在烟熏、碳化、受热变形任一情况，且单个部件缺陷面积大于等于0.3平方米，即认定为火烧车。 </div></div><div class=\"ui__comTitle_model_cnt_item\" data-v-9c9654ae><div class=\"ui__comTitle_model_cnt_title\" data-v-9c9654ae>泡水标准说明</div><div class=\"ui__comTitle_model_cnt_text\" data-v-9c9654ae> 泡水车定义：经水等导电液体浸泡进入车舱内的车辆。<br data-v-9c9654ae> 判定标准：座椅滑轨、安全带、座椅坐垫底部、车顶篷、行李箱、保险丝盒、发动机舱、点烟器底座、地胶（毯）、转向柱、柱夹层及周边，驾驶室内控制单元等发现有明显的泡水迹象（例如：含泥沙、水印、锈蚀、霉斑等情况）若存在三种或大于三种情况的，即认定为泡水车（因潮湿导致的浮锈除外）。仅地胶（毯）、座椅滑轨、行李箱底板存在相应缺陷，不判定为泡水车，但是必须在报告在中注明。 </div></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        class: "ui__checkDetail_title_right",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showModel && _ctx.showModel(...args)))
      }, [
        _hoisted_4,
        _hoisted_5
      ])
    ]),
    _withDirectives(_createVNode("div", {
      class: "ui__comTitle_model_cover",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
    }, null, 512), [
      [_vShow, _ctx.state.isShowModel]
    ]),
    _withDirectives(_createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("img", {
          src: require('../../../assets/image/close-icon.png'),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
        }, null, 8, ["src"])
      ]),
      _hoisted_9
    ], 512), [
      [_vShow, _ctx.state.isShowModel]
    ])
  ]))
})